<template>
  <div class="home">
    <section class="hero is-primary is-medium">
      <div class="hero-body">
        <div class="container">
          <h1 class="title">
            {{ heading }}
          </h1>
          <div class="is-two-thirds column is-paddingless">
            <h2 class="subtitle is-4">{{ subheading }}</h2>
          </div>
          <div class="is-half column lotos">
            <router-link to="/lotos" class="button lotos-more is-info is-medium" id="learn"><span class="text">了解更多</span><span class="icon"><i class="fa fa-arrow-right" aria-hidden="true"></i></span></router-link>
          </div>
        </div>
      </div>
    </section>

    <section class="section">
      <div class="container">
        <div class="tile is-ancestor special-charact">
          <div class="tile is-parent is-6">
            <article class="tile is-child">
              <figure class="image">
                <img src="../assets/healthy.png">
              </figure>
            </article>
          </div>
          <div class="tile is-parent is-vertical">
            <article class="tile is-child notification box">
              <p class="title">首創健康仿生宅概念</p>
              <p>建築物的外牆水泥砂漿添加樂土,如同戶外服飾的設計理念,仿生兼具防水透氣的功能,是建築材料設計的靈魂。</p>
            </article>
            <article class="tile is-child notification box ">
              <p class="title">建築界的GORE-TEX</p>
              <p>完全針對台灣潮濕氣候設計的樂土，強化防水/防潮效果。如同穿上戶外機能性的GORE-TEX科技布料一般，讓建築具備透氣呼吸功效。</p>
            </article>
            <article class="tile is-child notification box">
              <p class="title">施作比例</p>
              <p>於水泥砂漿攪拌時，將2kg包裝的樂土防水粉混合一起加入攪拌均勻即可，樂土防水粉/水泥砂漿的比例為一包50kg的水泥配一包2kg的防水粉乾伴均勻後，再加上水與砂攪拌均勻才能施作喔！</p>
            </article>
          </div>        
        </div>
        <div class="columns pd">
          <div class="column" v-for="product in products">
            <div class="card">
              <div class="card-image">
                <figure class="image is-3by4">
                  <img v-bind:src="product.src"  alt="Placeholder image">
                </figure>
              </div>
              <div class="card-content">
                <div class="media">
                  <div class="media-left">
                    <figure class="image is-48x48">
                      <img v-bind:src="product.psrc" alt="Placeholder image">
                    </figure>
                  </div>
                  <div class="media-content">
                    <p class="title is-4">{{ product.title }}</p>
                    <p class="subtitle is-6">{{ product.desc}}</p>
                  </div>
                </div>

                <div class="content">
                    {{ product.longdesc }}
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  </div>
</template>

<script>
export default {
  name: 'home',
  data: function() {
    return {
      heading: '成大樂土 源自台灣 新世代智慧防水建材',
      subheading: '水庫淤泥利用再生，防水透氣，環保無毒，能預防壁癌的神奇配方',
      products: [
        {src: require('../assets/lotosanti2.jpg'), title: '抹壁型多效能防水粉', desc: '水泥防水添加劑', longdesc: '添加於水泥砂漿中，改善水泥砂漿先天不良的高吸水率問題，大幅降低吸水率到6%以下，並維持透氣性。', psrc: require('../assets/product1.png')},
        {src: require('../assets/lotospaster4.jpg'), title: '樂土灰泥', desc: '泥礦創藝修飾砂漿', longdesc: '快速施工，輕易把非水泥質感的底材轉化成工業設計風的水泥質感，表面光滑，施作厚度僅有0.3-0.5mm。', psrc: require('../assets/product2.png')},
        {src: require('../assets/lotoslasan.jpg'), title: '樂繕薄層防水砂漿', desc: 'DIY修補', longdesc: '將牆面壁癌處刨除，並用本色樂繕打底，白色樂繕當面層，局部修補家中牆面病變處，含有工具組及說明書。', psrc: require('../assets/product3.png')}
      ]    
    }
  }
}

</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="sass" scoped>
@import '../mq'

.hero
  background: url('../assets/image.jpg')
  background-size: cover

  .lotos
    text-align: right
    .lotos-more
      border: 1px solid cyan
      padding: 0 3rem
      +mobile
        padding: 0 1.5rem
        font-size: 1rem


  .title
    font-size: 3rem !important
    background-color: rgba(255, 255, 255, 0.4)
    color: $primary
    +mobile
      font-size: 2rem !important
    +tablet
      font-size: 2.5rem
    +desktop
      font-size: 4rem
      margin-top: 2.5rem
  
  h2
    margin: 1.5rem 0 2rem 0 !important 
    background-color: rgba(255, 255, 255, 0.4)
    color: #399 !important
    +mobile
      font-size: 1rem
  
.special-charact 
  .title
    color: #399
  .title + p
    color: #999
    font-size: 1.2rem
    +mobile
      font-size: 1rem

.fa-cog
  font-size: 40px

#learn
  +desktop
    margin-bottom: 2rem
    
.pd
  padding: 2rem 0
.card-content
  .media-left
    .image
      box-shadow: 0 2px 3px rgba(10, 10, 10, 0.1), 0 0 0 1px rgba(10, 10, 10, 0.1) 
</style>



// WEBPACK FOOTER //
// src/components/Home.vue